import { ReactNode } from 'react';

export const CheckIfChildHasPropertyHref = (item: ReactNode) => {
  let hasLink = false;
  const isArray = Array.isArray(item);

  if (isArray) {
    hasLink =
      item.length > 0 &&
      item.every((value) => {
        if (typeof value === 'object') {
          if ('href' in value.props) {
            return true;
          }
          return false;
        }
        return false;
      });
  }
  return hasLink;
};
